import { ChangeDetectorRef, Component, ElementRef, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { AuthentificationService } from "../services/auth/authentification.service";
import {BehaviorSubject, finalize, Subscription, combineLatest} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Notification } from '../models/Notification';
import { NotificationService } from '../services/notification/notification.service';
import {map, switchMap, take} from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import {MenuUtil} from "../utils/menu-utils";
import { TranslateService } from '@ngx-translate/core';
import { MenuNouveautesService } from 'lib-menu-nouveautes';
import {ProfilService} from "../services/mon-profil/profil.service";
import { EnvironmentService } from '../services/environment.service';
import { ConfigurationService } from '../services/configuration.service';
const ROLE_ADMIN = 'ROLE_ADMIN';
const ROLE_SUPERADMIN = 'ROLE_SUPERADMIN';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit ,OnDestroy{

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    loadingSubject = new BehaviorSubject<boolean>(false);
    fullName: string;
    avatarInitials: string;
    gender: string;

    access = null;
    listNotification: Notification[] = [];
    name: string;
    companyId: number;
    uuid: string;
    countNotif: number = 0;
    count: any;
    selectedLang: string = this.cookieService.get('language')
    disconnected: boolean = false;
    langs = this.environmentService.get().languages;
    showLangs = this.configurationService.get().languages.show;
    displayNotification: boolean = this.configurationService.get().notification.show;

  showSuiviDemande = new BehaviorSubject<boolean>(false);
  showCourriers = new BehaviorSubject<boolean>(false);
  showDsn = new BehaviorSubject<boolean>(false);
  subscription : Subscription;
  isLoading: boolean = true;
  noNotifications: boolean = false;


  data: any[] = [];
  nbUnreadNouveaute = 0;


    constructor(private notificationService: NotificationService, private profilService :ProfilService,
        public layoutService: LayoutService, public el: ElementRef, private AuthServ: AuthentificationService,
        private router: Router,private changeDetectorRef: ChangeDetectorRef, private cookieService: CookieService,public translate:TranslateService , private service: MenuNouveautesService, private environmentService: EnvironmentService, private configurationService: ConfigurationService) {  }

    ngOnInit(): void {
      this.profilService.fullName$.subscribe((name) => {
        this.fullName = name;
      });
        this.access = this.AuthServ.getStoredAccess();
        this.companyId = this.access.companyId;
        this.uuid = this.access.uuid
        this.getUserLogged();

      this.showAlertDsn();
      this.showDemandeNotification();
      this.showCourrierNotification();


        if(this.access.roles.filter(role => role == ROLE_SUPERADMIN).length > 0) {
            this.layoutService.checkIfSuperAdmin().subscribe(() => {})
        }
        if(this.access.roles.filter(role => role == ROLE_ADMIN).length > 0) {
            this.layoutService.checkIfAdmin().subscribe(() => {})
        }

      this.service.data$.subscribe(data => {
        this.data= data;
        this.nbUnreadNouveaute = data.filter(item => item.read === false).length;

      });
      this.getNotifications();
    }

  private showAlertDsn(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.subscription = MenuUtil.localStorageChanges.subscribe((menu) => {
        if (menu) {
          const route = MenuUtil.fetchRouteByPath(MenuUtil.alertDsnUrl);
          if (route) {
            this.showDsn.next(true);
          }
          resolve();
        }
      });
    });
  }

  private showCourrierNotification(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.subscription = MenuUtil.localStorageChanges.subscribe((menu) => {
        if (menu) {
          const route = MenuUtil.fetchRouteByPath(MenuUtil.courriers);
          if (route) {
            this.showCourriers.next(true);
          }
          resolve();
        }
      });
    });
  }

  private showDemandeNotification(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.subscription = MenuUtil.localStorageChanges.subscribe((menu) => {
        if (menu) {
          const route = MenuUtil.fetchRouteByPath(MenuUtil.suiviDemande);
          if (route) {
            this.showSuiviDemande.next(true);
          }
          resolve();
        }
      });
    });
  }

    ngOnDestroy() {
      this.resetNotificationWatchers();
        this.subscription?.unsubscribe();
    }

  getNotifications() {
    this.access = this.AuthServ.getStoredAccess();
    this.loadingSubject.next(true);

    // Appeler les méthodes pour mettre à jour les variables
    const alertDsnPromise = this.showAlertDsn();
    const courrierNotificationPromise = this.showCourrierNotification();
    const demandeNotificationPromise = this.showDemandeNotification();
    // Attendre que toutes les promesses soient résolues avant de continuer
    Promise.all([alertDsnPromise, courrierNotificationPromise, demandeNotificationPromise]).then(() => {
      combineLatest([
        this.showSuiviDemande.asObservable(),
        this.showCourriers.asObservable(),
        this.showDsn.asObservable()
      ]).pipe(
        take(1), // Prendre la première émission et terminer
        switchMap(values => {
          return this.notificationService.getNotifications(this.access.companyId, this.access.uuid,'DC').pipe(
            map((data: any) => ({
              data: data.items,
              values: values
            })),
            finalize(() => {
              this.loadingSubject.next(false);
              this.updateNotificationState();
            })
          );
        })
      ).subscribe({
        next: ({ data, values }) => {
          this.listNotification = data;
          this.calculateTotalNotifications(data, values);
          this.updateNotificationState();
        },
        error: (error: any) => {
          console.error("Erreur lors de la récupération des notifications :", error);
          this.updateNotificationState();
        }
      });
    }).catch(error => {
      console.error("Erreur lors de la mise à jour des variables :", error);
      this.loadingSubject.next(false);
    });
  }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showRightMenu();
    }

    onSearchClick() {
        this.layoutService.toggleSearchBar();
    }

    onRightMenuClick() {
        this.layoutService.showRightMenu();

        let newlyReadItems = this.data
        .filter((item) => item.read === false)
        .map((item) => item.id);
      this.service.markAsSeen(newlyReadItems).subscribe();
    }

    get logo() {
        const logo = this.layoutService.config.menuTheme === 'white' || this.layoutService.config.menuTheme === 'orange' ? 'dark' : 'white';
        return logo;
    }

    goToProfile() {
        this.router.navigateByUrl('/mon-profil');
    }

    logout() {
        this.AuthServ.clearAccessStorage();
      if(this.environmentService.get()?.ssoAcces?.SHOW){
        window.location.href = this.environmentService.get()?.ssoAcces?.Link;

      }else{
      this.router.navigate(['/auth/login']);
      }
  }

    get userInitial(): string {
        // Récupérer l'initial de l'utilisateur
        return this.access.prenom.charAt(0)+ "" + this.access.nom.charAt(0);
    }

    getUserLogged() {
        this.loadingSubject.next(true);
        this.fullName = this.access?.prenom + " " + this.access?.nom;
        this.avatarInitials = this.access?.prenom?.charAt(0)+ "" + this.access?.nom?.charAt(0);
    }
  onChangeLang() {
    this.translate.setDefaultLang(this.selectedLang);
    this.translate.use(this.selectedLang);
    this.cookieService.set('language', this.selectedLang);
    window.location.reload();
  }

  private updateNotificationState(): void {
    this.isLoading = this.loadingSubject.getValue();
    this.noNotifications = !this.isLoading && this.countNotification === 0;
  }

  private resetNotificationWatchers() {
    this.notificationService.countDsnNotificationSubject.next(0)
    this.notificationService.countGedNotificationSubject.next(0);
    this.notificationService.countDemandNotificationSubject.next(0);
    this.notificationService.countAmountNotificationSubject.next(0);
  }
  private calculateTotalNotifications(notifications: any[], [showSuiviDemande, showCourriers, showDsn]: boolean[]): number {
    let total = 0;
    notifications.forEach(notification => {
      if (notification.source === 'DEMANDES' && showSuiviDemande) {
        total += notification.notification;
        this.notificationService.countDemandNotificationSubject.next(notification.notification);
      } else if (notification.source === 'GED' && showCourriers) {
        total += notification.notification;
        this.notificationService.countGedNotificationSubject.next(notification.notification);
      } else if (notification.source === 'SIGNALEMENT' && showDsn) {
        this.notificationService.countDsnNotificationSubject.next(notification.notification)
        total += notification.notification;
      } else if (notification.source === 'MONTANT') {
        this.notificationService.countAmountNotificationSubject.next(notification.notification)
      }
    });
    return total;
  }
  get countNotification(){
      // Le montant de paiement n'est pas calculé avec la somme
    return this.countDsnNotification + this.countDemandNotification + this.countGedNotification;
  }
  get countDsnNotification(){
    return this.notificationService.countDsnNotificationSubject.getValue();
  }
  get countDemandNotification(){
    return this.notificationService.countDemandNotificationSubject.getValue();
  }
  get countGedNotification(){
    return this.notificationService.countGedNotificationSubject.getValue();
  }
  get countAmountNotification(){
    return this.notificationService.countAmountNotificationSubject.getValue();
  }
}
